import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

// Add token to headers
const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getColors = async () => {
  // const response = await axios.get(`${base_url}color/all`);
  const response = await axios.get(`${base_url}color/all`, getAuthHeaders());
  return response.data;
};
const createColor = async (color) => {
  // const response = await axios.post(`${base_url}color/add`, color, config);
  const response = await axios.post(`${base_url}color/add`, color, getAuthHeaders());
  return response.data;
};

const updateColor = async (color) => {
  // const response = await axios.put(
  //   `${base_url}color/edit/${color.id}`,
  //   { color_name: color.colorData.color_name },
  //   config
  // );

  const response = await axios.put(
    `${base_url}color/edit/${color.id}`,
    { color_name: color.colorData.color_name },
    getAuthHeaders()
  );

  return response.data;
};
const getColor = async (id) => {
  // const response = await axios.get(`${base_url}color/get/${id}`, config);
  const response = await axios.get(`${base_url}color/get/${id}`, getAuthHeaders());
  return response.data;
};

const deleteColor = async (id) => {
  // const response = await axios.delete(`${base_url}color/delete/${id}`, config);
  const response = await axios.delete(`${base_url}color/delete/${id}`, getAuthHeaders());
  return response.data;
};
const colorService = {
  getColors,
  createColor,
  updateColor,
  getColor,
  deleteColor,
};

export default colorService;
